import axios from "axios"

// 封装一个函数，接收一个参数来动态赋值axios的baseURL
function diffReq(baseURL) {
  const service = axios.create({
    timeout: 30000,
    baseURL
  })
  return service
}

export default diffReq


// WEBPACK FOOTER //
// ./src/utils/diffReq.js